import {
  Chat,
  EnvelopeSimple,
  Microphone,
  NoteBlank,
} from "@phosphor-icons/react";

import type { LinkedInProfile } from "common/types";

import {
  InmailTemplateSchema,
  MessageTemplateSchema,
  NoteTemplateSchema,
  VoiceTemplateSchema,
} from "./schemas";

export const TEMPLATE_VARIABLES: { value: string; name: string }[] = [
  { value: "{{LINKEDIN.FIRST_NAME}}", name: "First name" },
  { value: "{{LINKEDIN.LAST_NAME}}", name: "Last name" },
  { value: "{{LINKEDIN.OCCUPATION}}", name: "Occupation" },
  { value: "{{LINKEDIN.LOCATION}}", name: "Location" },
  { value: "{{LINKEDIN.ID}}", name: "ID" },
  { value: "{{LINKEDIN.CURRENT_COMPANY}}", name: "Current Company" },
  {
    value: "{{LINKEDIN.TIME_AT_CURRENT_COMPANY}}",
    name: "Time at Current Company",
  },
  // Sender variables
  { value: "{{SENDER.FIRST_NAME}}", name: "Sender First name" },
  { value: "{{SENDER.LAST_NAME}}", name: "Sender Last name" },
  { value: "{{SENDER.OCCUPATION}}", name: "Sender Occupation" },
  { value: "{{SENDER.LOCATION}}", name: "Sender Location" },
  { value: "{{SENDER.ID}}", name: "Sender ID" },
  { value: "{{SENDER.CURRENT_COMPANY}}", name: "Sender Current Company" },
  {
    value: "{{SENDER.TIME_AT_CURRENT_COMPANY}}",
    name: "Sender Time at Current Company",
  },
];

export const TEMPLATE_TYPES = {
  NOTE_TEMPLATE: {
    label: "Connection note",
    shortLabel: "Note",
    icon: NoteBlank,
    validationSchema: NoteTemplateSchema,
  },
  MESSAGE_TEMPLATE: {
    label: "Direct message",
    shortLabel: "Message",
    icon: Chat,
    validationSchema: MessageTemplateSchema,
  },
  INMAIL_TEMPLATE: {
    label: "Free InMail",
    shortLabel: "InMail",
    icon: EnvelopeSimple,
    validationSchema: InmailTemplateSchema,
  },
  VOICE_TEMPLATE: {
    label: "Voice message",
    shortLabel: "Voice",
    icon: Microphone,
    validationSchema: VoiceTemplateSchema,
  },
} as const;

export const AIMFOX_TEMPLATE_PREVIEW_ACCOUNT: LinkedInProfile = {
  email: "",
  first_name: "Aleksandar",
  last_name: "Besarovic",
  id: "350311515",
  full_name: "Aleksandar Besarovic",
  public_identifier: "aleksandar-besarovic",
  picture_url:
    "https://cdn.constel.co/linkedin-profile/ACoAABThVFsBoJzUUWcsZdWPXIoL8U3iyMOnsqE.jpg",
  occupation: "CEO at Aimfox.com",
  urn: "ACoAABThVFsBoJzUUWcsZdWPXIoL8U3iyMOnsqE",
  location: {
    name: "Serbia",
    urn: "101855366",
  },
  premium: false,
};

export const WHITE_LABEL_TEMPLATE_PREVIEW_ACCOUNT: LinkedInProfile = {
  id: "19186432",
  urn: "ACoAAAEkwwAB9KEc2TrQgOLEQ-vzRyZeCDyc6DQ",
  email: "",
  first_name: "Satya",
  last_name: "Nadella",
  full_name: "Satya Nadella",
  occupation: "Chairman and CEO at Microsoft",
  location: {
    name: "Seattle, Washington, United States",
    urn: "104116203",
  },
  public_identifier: "satyanadella",
  picture_url:
    "https://cdn.constel.co/linkedin-profile/ACoAAAEkwwAB9KEc2TrQgOLEQ-vzRyZeCDyc6DQ.jpg",
  premium: false,
};

export const TEMPLATE_PREVIEW_ACCOUNTS: LinkedInProfile[] = [
  {
    email: "",
    first_name: "Richard",
    last_name: "Branson",
    id: "204068115",
    full_name: "Richard Branson",
    public_identifier: "rbranson",
    picture_url:
      "https://cdn.constel.co/linkedin-profile/ACoAAAwp1RMBxG26M3Qkhm4klqLNr1bIplo6GhY.jpg",
    occupation: "Founder at Virgin Group",
    urn: "ACoAAAwp1RMBxG26M3Qkhm4klqLNr1bIplo6GhY",
    premium: false,
  },
  {
    email: "",
    first_name: "Bill",
    last_name: "Gates",
    id: "251749025",
    full_name: "Bill Gates",
    public_identifier: "williamhgates",
    picture_url:
      "https://cdn.constel.co/linkedin-profile/ACoAAA8BYqEBCGLg_vT_ca6mMEqkpp9nVffJ3hc.jpg",
    occupation: "Chair, Gates Foundation and Founder, Breakthrough Energy",
    urn: "ACoAAA8BYqEBCGLg_vT_ca6mMEqkpp9nVffJ3hc",
    location: {
      name: "Seattle, Washington, United States",
      urn: "104116203",
    },
    premium: false,
  },
];
